module.exports = __webpack_public_path__ + "static/media/goodnest_app8_preview.c7f746dc.jpg";